import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AnalyticsService } from "../../@core/utils";
import { StorageService } from './../../services/storage.service';

@Component({
  selector: "ngx-mat-dialog",
  templateUrl: "./mat-dialog.component.html",
  styleUrls: ["./mat-dialog.component.scss"],
})
export class MatDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<MatDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public analyticsService: AnalyticsService,
    public storageService : StorageService
  ) {
    this.storageService.isDialogComponentOpen.emit(true)
  }

  onCancel(message: string, pageTitle: string): void {
    this.analyticsService?.trackEvent(message, pageTitle);
    this.dialogRef.close(false);
    this.storageService.isDialogComponentOpen.emit(false)
  }

  onConfirm(message: string, pageTitle: string): void {
    this.analyticsService?.trackEvent(message, pageTitle);
    this.dialogRef.close(true);
    this.storageService.isDialogComponentOpen.emit(false)
  }
}
